module.exports = __webpack_public_path__ + "img/zhengzaifangkuan.1451000e.png";